import { AnyUser } from "@megaron/access-control";
import { diffSyncActions } from "@megaron/diff-sync-contracts";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { bi } from "./bi";
import { contacts } from "./contacts";
import { customerAnalyticsActions } from "./customerAnalytics";
import { customerDocActions } from "./customerDoc";
import { customers } from "./customers";
import { history } from "./history";
import { legacyActions } from "./legacy";
import { legacyEdiActions } from "./legacyEdi";
import { margins } from "./margins";
import { orderDraftActions } from "./orderDrafts";
import { orderActions } from "./orders";
import { productAvailabiliy } from "./productAvailability";
import { crmDiffSyncSchema } from "./pricingRules";
import { purchases } from "./purchases";
import { regions } from "./regions";
import { relations } from "./relation";
import { trainings } from "./trainings";
import { transactionActions } from "./transactions";

export const crmHttpService = HttpService({
  ...customers,
  ...history,
  ...purchases,
  ...regions,
  ...contacts,
  ...bi,
  ...relations,
  ...orderActions,
  ...transactionActions,
  ...margins,
  ...customerAnalyticsActions,
  ...legacyEdiActions,
  ...customerDocActions,
  ...orderDraftActions,
  ...trainings,
  ...productAvailabiliy,
  ...legacyActions,
  ...diffSyncActions(crmDiffSyncSchema),
});

export type CrmHandlers = HandlerMap<typeof crmHttpService, AnyUser>;
